import moment from "moment-timezone";

export const formatTaipeiProjectTime = value => {
    if (!value) return "";
    const utcTime = moment.utc(value);
    if (!utcTime.isValid()) return "";
    return utcTime.tz("Asia/Taipei").format("YYYY/MM/DD HH:mm");
};

export const getNonSuperUsers = users => (users || [])
    .filter(user => !user.isSuperUser)
    .sort((left, right) => String(left.username || "").localeCompare(
        String(right.username || ""),
        undefined,
        { sensitivity: "base" }
    ));

export const chooseScopedProjectId = (projects, currentProjectId) => {
    const items = projects || [];
    if (items.some(project => project.projectId === currentProjectId)) {
        return currentProjectId;
    }
    return items.find(project => project.isProjectDefault)?.projectId
        || items[0]?.projectId
        || null;
};
